import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, Spin, Input } from 'antd'
import '../../css/form.scss'
import _ from 'lodash'
import util from '../../util/util'
import { getForm } from '../../store/action/patient.action'
import { useParams } from 'react-router'
import moment from 'moment'
import { useReactToPrint } from 'react-to-print'
import {
  PrinterOutlined,
  CheckCircleFilled,
  ArrowLeftOutlined,
  ArrowRightOutlined,
} from '@ant-design/icons'
import serviceInterface from '../../services/service.interface'
import { constants } from '../../constants'

const Forms = (props) => {
  // const params = useParams();
  const [form, setForm] = useState({})
  var ref = useRef()

  const [formarr, setFormArr] = useState([])
  const [rightForm, setRightForm] = useState(false)
  const [leftForm, setLeftForm] = useState(false)
  const [formindex, setFormindex] = useState(-1)

  useEffect(() => {
    if (props.form) {
      setForm(props.form)
      setFormindex(0)
    }
  }, [])
  useEffect(() => {
    if (props.formid) {
      ;(async () => {
        var data = props.formid ? await props.fetchForm(props.formid) : {}
        if (data) {
          setForm(data)
          getLastForm(data.shortname)
        }
      })()
    }

    getLastForm(props.type)
  }, [props.formid])

  const handlechange = async (index) => {
    var data = await props.fetchForm(formarr[index]._id)
    if (data) {
      setForm(data)
    }
  }

  var handlePrint = useReactToPrint({
    content: () => ref.current,
    // onAfterPrint: () => ref.current.className = "formContainer",
    // onBeforeGetContent: () => ref.current.className = "formContainer formPrintContainer"
  })

  var renderOptions = (options) => {
    return options.map((option) => {
      return (
        <Row className={option.selected ? 'option selected' : 'option'}>
          <Col>{option.optnumber}&nbsp;</Col>
          <Col>{option.option}</Col>
          <Col hidden={!option.text} className='inputBox'>
            <Input value={option.text} disabled />
          </Col>
          <Col hidden={!option.selected}>
            &nbsp;&nbsp;
            <CheckCircleFilled className='checkIcon' />
          </Col>
        </Row>
      )
    })
  }
  const getLastForm = async (formtype) => {
    var res = serviceInterface.PatientService().getAllForm({
      formtype,
      schedules: props.patient?.feedbackSchedule
        ? [...props.patient?.feedbackSchedule?.feedbackdateschedule]
        : [],
    })
    if (res && res.length > 0) {
      var index = null
      if (!props.formid) {
        var data = await props.fetchForm(res[res.length - 1]._id)
        if (data) setForm(data)
        index = res.length - 1
        setFormindex(index)
      } else {
        index = _.findIndex(res, { _id: props.formid })
        setFormindex(index)
      }
      setFormArr(res)
      if (index < res.length - 1) setRightForm(true)
      if (index > 0) setLeftForm(true)
    }
    // else props.close()
  }

  const getRightForm = () => {
    if (formarr.length - 1 > formindex) {
      setFormindex(formindex + 1)
      if (formindex + 1 == formarr.length - 1) setRightForm(false)
      if (formarr.length > 1) setLeftForm(true)
      handlechange(formindex + 1)
    }
  }

  const getLeftForm = () => {
    if (formindex - 1 >= 0) {
      setFormindex(formindex - 1)
      if (formindex - 1 == 0) setLeftForm(false)
      if (formarr.length > 1) setRightForm(true)
      handlechange(formindex - 1)
    }
  }

  var renderQuestions = () => {
    return form.questions
      ? form.questions.map((question, index) => {
          return (
            <Col flex='100%'>
              <Row className='question'>
                {question.questnumber})&nbsp;{question.question}
              </Row>
              <Row>
                <Col className='optionsContainer'>
                  {renderOptions(question.options)}
                </Col>
              </Row>
            </Col>
          )
        })
      : null
  }

  return (
    <Spin spinning={props.isLoading}>
      <Row>
        <div ref={ref} className='formContainer formPrintContainer'>
          {!props.isLoading && formindex == -1 && (
            <Row align='middle'>
              <Col
                flex={'auto'}
                style={{
                  fontSize: 24,
                  textAlign: 'center',
                  marginTop: 10,
                  fontWeight: 400,
                }}
              >
                {props.type} <br />
                <span style={{ fontSize: 18 }}>Data not recorded</span>
              </Col>
            </Row>
          )}
          {formindex != -1 && (
            <>
              <Row className='headerRow' align='middle'>
                <Col flex={'auto'}>
                  <Row className='formHeader'>
                    <Col hflex={'5%'}>
                      <ArrowLeftOutlined
                        hidden={!leftForm}
                        style={{ cursor: 'pointer' }}
                        onClick={getLeftForm}
                      />
                    </Col>
                    <Col flex={'80%'} style={{ textAlign: 'center' }}>
                      {form.shortname}
                    </Col>
                    <Col flex={'5%'}>
                      <ArrowRightOutlined
                        hidden={!rightForm}
                        style={{ cursor: 'pointer' }}
                        onClick={getRightForm}
                      />
                    </Col>
                  </Row>

                  <Row hidden={props.form} container justify='space-around'>
                    {/* <Row className="printRow" align="middle">
                                <Col style={{fontSize: 18}} flex={"22px"}>
                                    <PrinterOutlined onClick={handlePrint} />
                                </Col>
                                <Col onClick={handlePrint} style={{cursor: "pointer"}}>Print</Col>
                                </Row> */}

                    <Col flex={6}>
                      <Row>
                        {' '}
                        <b>Assigned on:</b>
                      </Row>
                      <Row>{moment(form.date).format('MM/DD/YYYY')}</Row>
                    </Col>

                    <Col flex={6}>
                      <Row>
                        <b>Completed on:</b>
                      </Row>
                      <Row>{moment(form.submittime).format('MM/DD/YYYY')}</Row>
                    </Col>

                    <Col flex={6} hidden={form.score == 0}>
                      <Row>
                        {' '}
                        <b>
                          {form.shortname == constants.SCORE.PAIN_LEVEL
                            ? constants.SCORE.PAIN_LEVEL_V2
                            : form.shortname == constants.SCORE.KNEE_SCORE
                              ? constants.SCORE.KNEE_SCORE_v2
                              : 'Score'}
                          :
                        </b>
                      </Row>
                      <Row> {form.score}</Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className='quesContainer' gutter={[16, 16]}>
                {renderQuestions()}
              </Row>
            </>
          )}
        </div>
      </Row>
    </Spin>
  )
}

Forms.propTypes = {
  patient: PropTypes.object,
  date: PropTypes.object,
  exercises: PropTypes.array,
  isLoading: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    patient: state.patient.patient,
    isLoading: state.profile.isLoading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchForm: (id) => dispatch(getForm(id)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Forms)
